import { render, staticRenderFns } from "./expressInfo.vue?vue&type=template&id=075cc4c3&scoped=true"
import script from "./expressInfo.vue?vue&type=script&lang=js"
export * from "./expressInfo.vue?vue&type=script&lang=js"
import style0 from "./expressInfo.vue?vue&type=style&index=0&id=075cc4c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075cc4c3",
  null
  
)

export default component.exports